import { formatMoney } from '@/utils/money-util'
import { m, useTransform } from 'motion/react'
import { useSpringValue } from '@/hooks/motion-hooks'
import styles from './Amount.module.css'

interface AmountProps {
  /**
   * The amount. Will be formatted as money.
   */
  value: number
  /**
   * If `true`, will not use special styles to denote positive or negative numbers.
   */
  neutral?: boolean
}

/**
 * The Amount component.
 */
export function Amount({ neutral = false, value: valueInput }: AmountProps) {
  const value = useSpringValue(valueInput)
  const color = useTransform(value, (v) => getColor(v, neutral))
  const text = useTransform(value, (n) => formatMoney(n))

  return (
    <m.span className={styles.root} style={{ color }}>
      {text}
    </m.span>
  )
}

function getColor(value: number, neutral: boolean) {
  if (neutral) {
    return 'auto'
  }

  if (value < 0) {
    return 'var(--red500)'
  } else if (value > 0) {
    return 'var(--green500)'
  }

  return 'auto'
}
